import React, { FC } from 'react';
import {
  BoxV2 as Box,
  ButtonV2 as Button,
  Flex,
  SxProps,
} from 'portal-commons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons';

interface SectionCardProps {
  title: string;
  icon?: IconDefinition;
  onEdit?: () => void;
  editable?: boolean;
  customButton?: React.ReactNode;
  sx?: SxProps;
  dataTestId?: string;
}

const SectionCard: FC<SectionCardProps> = ({
  title,
  icon,
  onEdit,
  editable = false,
  customButton,
  sx,
  children,
  dataTestId,
}) => {
  return (
    <Box
      data-testid={dataTestId}
      sx={{
        border: '1px solid #CCCFD0',
        borderRadius: '8px',
        width: '100%',
        py: 24,
        px: 16,
        ...sx,
      }}
    >
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          my: 4,
          gap: 24,
          color: '#4D5659',
          mb: 16,
        }}
      >
        {/* Left: icon + title */}
        <Flex sx={{ gap: 8, alignItems: 'center', justifyContent: 'center' }}>
          {icon && (
            <Flex
              as="span"
              sx={{
                height: 24,
                fontSize: '22px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FontAwesomeIcon icon={icon} />
            </Flex>
          )}
          <Box as="h2" sx={{ fontSize: '18px', fontWeight: 600 }}>
            {title}
          </Box>
        </Flex>
        {/* Right: pen_icon + edit  */}
        {editable && (
          <Button
            data-testid={dataTestId && `${dataTestId}_editIcon`}
            variant="transparent"
            shape="square"
            startAdornment={faPen}
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
        {customButton && (
          <span data-testid={dataTestId && `${dataTestId}_button`}>
            {customButton}
          </span>
        )}
      </Flex>
      <Box
        sx={{
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 'normal',
          color: '#4D5659',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SectionCard;
